import Alert from '@storeblocks/alert';
import { type FC } from 'react';

import { QueryState } from '@/api/components/QueryState';
import { usePortfoliosQuery } from '@/api/portfolios';
import { isNotReady } from '@/api/utils/isNotReady';
import { MainContent } from '@/components/MainContent';
import { TransactionsTable } from '@/components/TransactionsTable/TransactionsTable';
import { WithGap } from '@/components/WithGap';
import { useTexts } from '@/hooks/useTexts';

export const TransactionsPage: FC = () => {
  const texts = useTexts();
  const portfoliosQuery = usePortfoliosQuery();
  const hasPortfolios = (portfoliosQuery.data?.portfolioGroups.length || 0) > 0;

  if (isNotReady(portfoliosQuery)) {
    return <QueryState query={portfoliosQuery} />;
  }

  return (
    <WithGap>
      <MainContent>
        {hasPortfolios ? (
          <TransactionsTable />
        ) : (
          <Alert
            description={texts.transactions.table.alert.noPortfolios}
            data-test="no-portfolio-alert"
          />
        )}
      </MainContent>
    </WithGap>
  );
};
